import { useCallback } from 'react';
import { MyLink } from '@ui-kit/Link';
import { Grid } from '@ui-kit/Grid';
import { useAppSelector } from '@app/redux/hooks';
import classNames from 'classnames';
import IconCart from './cart.svg';
import { ServiceEcommerce2 } from '@app/services/ServiceEcommerce';

import styles from '../ProductsUser.module.scss';

export const CartBlock = () => {
  const { cartList } = useAppSelector(state => state.productManagement);

  const basketOnClick = useCallback(() => {
    ServiceEcommerce2.goToCartHead();
    return true;
  }, []);

  return (
    <MyLink className={styles.Wrapper} href={'/basket/'} data-testid="header-btn-basket" onClick={basketOnClick}>
      <Grid row at gap={'10px'} className={classNames(styles.Container, !!cartList?.length && styles.Active)}>
        <IconCart width={28} height={25} />
        Корзина
        {!!cartList?.length && <span className={styles.cart}>{cartList?.length}</span>}
      </Grid>
    </MyLink>
  );
};
